import { alpha, styled } from "@mui/material";
import { calendarDayName } from "../classes.js";
const doNotForward = /* @__PURE__ */ new Set(["ownerState", "daySize", "palette"]);
const Button = styled("button", {
  name: calendarDayName,
  slot: "Button",
  overridesResolver: (_, styles) => [styles.button],
  shouldForwardProp: (prop) => !doNotForward.has(prop)
})(({ theme, daySize, palette, ownerState }) => {
  const accentColor = palette?.accentColor ?? (theme.vars ?? theme).palette.primary.main;
  const accentColorAlpha = palette?.accentColor ? alpha(palette.accentColor, 0.1) : theme.vars ? `rgba(${theme.vars.palette.primary.mainChannel} / 0.1)` : alpha(theme.palette.primary.main, 0.1);
  const textColor = palette?.textColor ?? (theme.vars ?? theme).palette.primary.contrastText;
  const disabled = ownerState?.day.type === "day" && ownerState.day.disabled;
  const selection = ownerState?.selection;
  const clickable = ownerState?.day.type === "day";
  return {
    width: daySize,
    height: daySize,
    margin: 0,
    padding: 0,
    outline: 0,
    color: "currentColor",
    zIndex: 2,
    position: "relative",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    borderWidth: 0,
    borderRadius: "3px",
    cursor: clickable ? "pointer" : "normal",
    pointerEvents: clickable ? "auto" : "none",
    backgroundColor: "transparent",
    ...(selection === "day" || selection === "rangeStart" || selection === "rangeEnd") && {
      color: textColor,
      background: accentColor
    },
    ...disabled && {
      "&::after": {
        top: 0,
        left: 0,
        width: "100%",
        height: "100%",
        content: '""',
        position: "absolute",
        // intentionally not using theme.vars, channel does not exist for common.white
        backgroundColor: alpha(theme.palette.common.white, 0.85)
      }
    },
    "&:hover": {
      ...selection === void 0 && {
        color: accentColor,
        background: accentColorAlpha
      },
      ...selection === "rangeMiddle" && {
        color: accentColor
      }
    }
  };
});
export {
  Button
};
//# sourceMappingURL=Button.js.map
